import React, {useEffect, useState} from 'react';

import {Box, Button, FormControlLabel, Grid, Theme,} from '@mui/material';

import makeStyles from "@mui/styles/makeStyles";
import {useAppSelector} from "../..//redux/hooks";
import Strings from "../../assets/strings";
import {getAdminEnums} from "../../services";
import {IAppUser, IAppUsermodulo, IUserEnum} from "../../redux/types/IAppUser";
import StyledCheckbox from "../../components/StyledCheckbox";


const useStyles = makeStyles((theme:Theme) => ({
  root: {
    // width: '100%',
    // overflowX: 'auto',
  },
  barTitle:{
    // padding: "6px 12px",
    // background: theme.palette.grey[200],
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    '& > label':{
      marginRight: 0
    }
  },
}));

export default function ListModulosUser({ data = [], onTabClick,notasCount }:{notasCount?:number, data:IAppUsermodulo[], onTabClick:(tab:number)=>void}) {
  const classes = useStyles();

  let {byId:appUser = ({} as IAppUser), status} = useAppSelector(state => state.appUsers);

  const [loading, setLoading] = useState(false);
  const [state, setState] = useState<IAppUser>();


  const [adminEnums, setAdminEnums] = useState<IUserEnum>();


  useEffect(()=>{
   if(appUser){
     setState(appUser)
   }else{
     setState(undefined)
   }
  },[appUser, setState])


  useEffect(()=>{
    getAdminEnums().then(({data})=>{
      setAdminEnums(data);
    })
  },[])
  const handleModuloCheck  = ({key,checked}:{key:number,checked:boolean})  => {
    let modulos = [...(state?.modulos??[])]

    if(checked) {
      modulos.push({modulo: key});
    }else {
      modulos = modulos?.filter(item => item.modulo !== key);
    }

    setState({...state,modulos});
  };



  const submitNota = (e:React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(false)

    // addAppUserNota({
    //   comentario: state.comentario,
    //   companiaId: appUser.id
    // }).then(res=>{
    // //  onUpdate([res.data, ...data])
    //   setState({comentario:""})
    //   setShowAddNew(false)
    // })


  };


  return (
    <>
      <div className={classes.barTitle}>
        <Box display={"flex"}>
          <Button onClick={()=>onTabClick(1)} variant="text" sx={{textTransform: "capitalize",height: "30px"}}>{Strings.pagos}</Button>
          <Button onClick={()=>onTabClick(2)} variant="text" sx={{textTransform: "capitalize",height: "30px",background:"#eeeeee !important"}}>Modulos</Button>
          <Button onClick={()=>onTabClick(3)} variant="text" sx={{textTransform: "capitalize",height: "30px"}}>
            {Strings.notas} ({notasCount ??0})
          </Button>
        </Box>
      </div >
      <Box p={2}>
        <Grid item xs={12}>
          <Grid container spacing={3}>
            {adminEnums?.modulos?.map((item)=>
                <Grid item  xs={6} md={3} key={item.key} >
                  <FormControlLabel
                      control={
                        <StyledCheckbox
                            checked={state?.modulos?.some(p=>p.modulo === item.key)}
                            // onChange={(e:any)=>handleModuloCheck({key: item.key!, checked: e.target.checked})}
                            color="primary"
                            inputProps={{
                              'aria-label': 'primary checkbox',
                              // name: acc.key.toString(), //+ '_' + acc.key,
                            }}
                        />
                      }
                      label={item.value}
                  />
                </Grid>
            )}
          </Grid>
        </Grid>
      </Box>


      {/*<Zoom*/}
      {/*    in={true}*/}
      {/*    // timeout={transitionDuration}*/}
      {/*    // style={{*/}
      {/*    //   transitionDelay: `${value === index ? transitionDuration.exit : 0}ms`,*/}
      {/*    // }}*/}
      {/*    unmountOnExit*/}
      {/*>*/}
      {/*  <Fab variant="extended" onClick={()=>setShowAddNew(true)}*/}
      {/*       sx={(theme)=>({*/}
      {/*         position: 'fixed',*/}
      {/*         right:smVewport?theme.spacing(1):undefined,*/}
      {/*         bottom: theme.spacing(2),*/}
      {/*         zIndex:2*/}
      {/*       })} size="small" color="primary" aria-label="agregar">*/}

      {/*    <SaveOutlined sx={{mr: 1}}/>*/}
      {/*    {Strings.guardar} Cambios*/}
      {/*  </Fab>*/}
      {/*</Zoom>*/}
    </>
  );
}

